import axios from 'axios';
const isMcpClient = () => {
    if (typeof window === 'undefined') return false;
    try {
        const hash = window.location.hash || '';
        const q = hash.indexOf('?');
        if (q === -1) return false;
        const params = new URLSearchParams(hash.substring(q + 1));
        return !!params.get('SL_Token');
    } catch {
        return false;
    }
};

const isStorageUrl = (url) => {
    try {
        const host = new URL(String(url), window.location.href).hostname;
        return host.endsWith('.amazonaws.com') || host.endsWith('.cloudfront.net');
    } catch {
        return false;
    }
};

// Create a central Axios instance for future use (as requested by the backend team)
const apiClient = axios.create();

// 1. AXIOS INTERCEPTOR
// This will automatically attach the x-client-id header to any request made with this Axios instance.
apiClient.interceptors.request.use((config) => {
    const clientId = isMcpClient() ? 'mcpclient' : 'webportal';
    
    if (!isStorageUrl(config.url)) {
        config.headers['x-client-id'] = clientId;
    }
    return config;
});

export default apiClient;

// 2. FETCH WRAPPER (for legacy code migration)
// Since the codebase currently uses native `fetch()` in over 60 places, converting everything 
// to Axios would require rewriting all response handling (res.ok, res.json(), res.blob(), etc).
// This wrapper injects the same `x-client-id` logic but preserves the exact native `fetch` signature.
export const fetchWrapper = async (url, options = {}) => {
    const clientId = isMcpClient() ? 'mcpclient' : 'webportal';

    // Clone options to avoid mutating original object
    const newOptions = { ...options };
    
    // Ensure headers object exists
    // Handle both plain objects and Headers instances
    const currentHeaders = newOptions.headers || {};
    let finalHeaders = {};
    
    if (currentHeaders instanceof Headers) {
        currentHeaders.forEach((value, key) => {
            finalHeaders[key] = value;
        });
    } else {
        finalHeaders = { ...currentHeaders };
    }
    
    // Inject the mandatory header
    if (!isStorageUrl(url)) {
        finalHeaders['x-client-id'] = clientId;
    }
    newOptions.headers = finalHeaders;

    return fetch(url, newOptions);
};
